export enum PdrType {
    Domestic = 0,
    Condominium = 1,
    Public = 2,
    DifferentUsages = 3
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/pdrType.ts